module.exports = __webpack_public_path__ + "static/media/TTBlue.201813e7.svg";